import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"; // <-- import navigate
import styles from "./FloorplanSummaryCard.module.css";

import bedIcon from './assets/bed_Icon.png';
import tubIcon from './assets/tub_Icon.png';
import cropIcon from './assets/crop_Icon.png';
import carIcon from './assets/car_Icon.png';

export default function FloorplanSummayCard() {
    const activePlan = useSelector((state) => state.visualizer.activeFloorPlanData);
    const navigate = useNavigate(); 

    const handleClick = () => {
        navigate("/floorplans");
    };

    return (
        <>
            {activePlan &&
                <div className={styles.content}>
                    <h1>{activePlan.name}</h1>
                    <div className={styles.summaryCard}>
                        <ul>
                            <li>
                                <img src={bedIcon} alt="Beds Icon" />
                                <p><span>{activePlan.beds}</span> Beds</p>
                            </li>
                            <li>
                                <img src={tubIcon} alt="Baths Icon" />
                                <p><span>{activePlan.baths}</span> Baths</p>
                            </li>
                            <li>
                                <img src={cropIcon} alt="Sqft Icon" />
                                <p><span>{activePlan.sqft}</span> Sqft</p>
                            </li>
                            <li>
                                <img src={carIcon} alt="Cars Icon" />
                                <p><span>{activePlan.cars}</span> Cars</p>
                            </li>
                        </ul>
                    </div>

                    <button onClick={handleClick}>Back to Plans</button>
                </div>
            }
        </>
    );
}
